import { AirCraftModel } from '@models/air-craft.model';
import { Permission, Session } from '@models/auth.model';
import { AirportsGroup, CountryDDLModel, DropDownListCodeResponse } from '@models/dropdown-list.model';
import { SeatSelectedModel } from '@models/flight.model';
import { PartnerListResponse } from '@models/partner.model';
import { createAction, props } from '@ngrx/store';

export const dummyAction = createAction('[Common] Dummy action');
export const loadCabinDDLAction = createAction('[Common][Metadata] load cabin ddl action');
export const loadPartnerDDLAction = createAction('[Common][Metadata] load cabin ddl action');
export const loadAirPortDDLAction = createAction('[Common][Metadata] load airPort ddl action');
export const loadAirlineDDLAction = createAction('[Common][Metadata] load airline ddl action');
export const loadCountriesDDLAction = createAction('[Common][Metadata] load countries ddl action');
export const loadAircraftDDLAction = createAction('[Common][Metadata] load aircraft ddl action');
export const loadSessionAction = createAction('[Common][Metadata] load user session action');

export const loadSession = createAction(
    '[Common] load session user',
    props<{ session: Session | null }>()
);

export const loadDropdownListData = createAction(
    '[Common][Metadata] load dropdown data',
    props<{
        data: DropDownListCodeResponse[] | AirportsGroup[] | CountryDDLModel[] | AirCraftModel[] | PartnerListResponse[];
        key: 'cabinDDL' | 'airPortDDL' | 'airlineDDL' | 'countriesDDL' | 'airCrafts' | 'partnerDDL';
    }>()
);

export const changeListSeatSelected = createAction(
    '[Flight] change list seat selected',
    props<{ list: SeatSelectedModel[] }>()
);

export const loadPermission = createAction(
    '[Common][Metadata] Load user permission',
    props<{ permissions: Permission[] }>()
);

export const showLoadingUpdate = createAction(
    '[Common] Show Loading update',
    props<{ loading: boolean }>()
);
export const showLoading = createAction('[Common] Show Loading', props<{ loading: boolean }>());